module.exports = __webpack_public_path__ + "img/wheel.e576db6f.png";